import React, { Component, Fragment } from 'react';
import classnames from 'classnames';

import {Api} from '../../util';


const modalRoot = document.getElementById('root');
class FiledownRename extends Component {
    // comp
    constructor(props){
        super(props);
        this.state = {
            fmtList: [],
            pathList: [],
            fmtId: '',
            pathId: '',
            ordType: 'S'
        };
        this.hadnleOnChangeType = this.hadnleOnChangeType.bind(this);
        this.handleOnFmtChange = this.handleOnFmtChange.bind(this);
        this.handleOnPathChange = this.handleOnPathChange.bind(this);
    }
    async componentDidMount(){
        // await Promise.all([
        //     this.SearchFmt(),
        //     this.SearchPath()
        // ]);
        this.input && this.input.focus();
    }

    hadnleOnChangeType(ordType){
        this.setState({
            ordType
        })
    }

     // 포맷 검색
    async SearchFmt(){
        let fmtList = [];
        try{
            this.setState({loadingFlag: true});
            const resFmt = await Api.SearchFmt();
            fmtList = resFmt.files.fmt;
            this.setState({
                fmtList,
                fmtId: fmtList.length > 0 ? fmtList[0].ID : ''
            });
        } catch(e) {
            console.log(e, "SearchFmt");
        } finally {
            this.setState({
                loadingFlag: false
            });
        }
    }
    // 저장소 검색
    async SearchPath(){
        let pathList = [];
        try{
            this.setState({loadingFlag: true});
            const resPath = await Api.SearchPath();
            pathList = resPath.files.path;
            this.setState({
                pathList,
                pathId: pathList.length > 0 ? pathList[0].ID : ''
            });
        } catch(e) {
            console.log(e, "SearchPath");
        } finally {
            this.setState({
                loadingFlag: false
            });
        }
    }

    handleOnFmtChange(e){
        this.setState({ fmtId :e.target.value});
    }
    handleOnPathChange(e){
        this.setState({ pathId :e.target.value});
    }


    render() {
        const {
            hideFileHandler,
            refileName,
            fileNameChangeHandler,
            cancelFileHandler,
            fileKeyDown,
            fileToggle,
            memoChangeHandler,
            memo
        } = this.props;

        const {
            ordType,
            fmtList,
            pathList
        } = this.state;

        const saveOnClick = () => {
            const {ordType, fmtId, pathId} = this.state;
            hideFileHandler(ordType, fmtId, pathId);
        };

        const compoents = (
            fileToggle === 'img' ?
                <div id = "modal-wrap">
                <div className="filedown-form">
                    <div className="filedown-wrap">
                        <div className="filedown-item">
                            <div className="filedown-label">
                                저장할 파일명 
                            </div>
                            <div className="filedown-value">
                                <input type="text" 
                                readOnly
                                value={refileName} 
                                onChange={fileNameChangeHandler} 
                                onKeyDown={fileKeyDown}
                                ref = {ref => this.input = ref} />
                            </div>
                        </div>

                        <div className="filedown-item">
                            <div className="filedown-label">
                                설명 
                            </div>
                            <div className="filedown-value">
                                <input type="text" 
                                readOnly
                                value={memo}
                                onChange={memoChangeHandler} 
                                onKeyDown={fileKeyDown}
                                />
                            </div>
                        </div>

                        <div className="filedown-item button-wrap" >
                            <button onClick={saveOnClick}>확인</button>
                            <button onClick={cancelFileHandler}>취소</button>
                        </div>
                    </div>
                    
                </div>
            </div>
            :
                <div id = "modal-wrap">
                <div className="filedown-form">
                    {/* 영상파일 저장, 전송 기능 */}
                    {/* <div className="filedown-item downtype-menu">
                        <div className={classnames({'selected': ordType === 'S'})} onClick={e=>this.hadnleOnChangeType('S')}>저장</div>
                        <div className={classnames({'selected': ordType === 'O'})} onClick={e=>this.hadnleOnChangeType('O')}>전송</div>
                    </div> */}
                    <div className="filedown-wrap">
                    {ordType === 'O' &&
                        <Fragment>
                        <div className="filedown-item">
                            <div className="filedown-label">
                                포맷
                            </div>
                            <div className="filedown-value">
                                <select onChange={this.handleOnFmtChange}>
                                    {fmtList.length > 0 && fmtList.map(item => {
                                        return item.USEYN === 'Y' && <option key={item.ID} value={item.ID}>{item.NAME}</option>;
                                    })
                                    }
                                </select>
                            </div>
                        </div>
                        
                            <div className="filedown-item">
                                <div className="filedown-label">
                                    저장소 위치
                                </div>
                                <div className="filedown-value">
                                    <select onChange={this.handleOnPathChange}>
                                        {pathList.length > 0 && pathList.map(item => {
                                            return item.USEYN === 'Y' && <option key={item.ID} value={item.ID}>{item.PATHNAME}</option>;
                                        })
                                        }
                                    </select>
                                </div>
                            </div>
                        </Fragment>
                    }
                        <div className="filedown-item">
                            <div className="filedown-label">
                                저장할 파일명 
                            </div>
                            <div className="filedown-value">
                                <input type="text" 
                                value={refileName} 
                                onChange={fileNameChangeHandler} 
                                onKeyDown={fileKeyDown}
                                length="50"
                                ref = {ref => this.input = ref} />
                            </div>
                        </div>
                       
                        <div className="filedown-item">
                            <div className="filedown-label">
                                설명 
                            </div>
                            <div className="filedown-value">
                                <input type="text" 
                                value={memo}
                                onChange={memoChangeHandler} 
                                onKeyDown={fileKeyDown}
                                />
                            </div>
                        </div>
                        <div className="filedown-item button-wrap">
                            <button onClick={saveOnClick} >확인</button>
                            <button onClick={cancelFileHandler}>취소</button>
                        </div>
                    </div>
                    
                    
                    </div>
                </div>
            );
            
        return compoents;
    }
}

export default FiledownRename;


// WEBPACK FOOTER //
// ./src/components/modal/FiledownRename.js